import { render, staticRenderFns } from "./TheRankingPreferenceTd.vue?vue&type=template&id=c554e5ba&scoped=true&lang=pug&"
import script from "./TheRankingPreferenceTd.vue?vue&type=script&lang=js&"
export * from "./TheRankingPreferenceTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c554e5ba",
  null
  
)

export default component.exports